import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { Subscription } from 'rxjs';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { CompetitionRoundCourseRatings } from 'src/data/mygolf.data';
import { MessageDisplayUtil } from 'src/message-display-utils';

@Component({
  selector: 'app-description-modal',
  templateUrl: './description-modal.page.html',
  styleUrls: ['./description-modal.page.scss'],
})
export class DescriptionModalPage implements OnInit {
  public title: string;
  public descriptionText: string;
  public headerName: string;

  @Input() descriptionMenuActive: string;
  @Input() competition: any;
  @Input() details: any;
  @Input() roundCourseRatings: Array<CompetitionRoundCourseRatings>;
  @Input() message: any;
  @Input() totalRounds: number;
  @Input() isError: boolean = false;
  @Input() isWarning: boolean = false;

  constructor(
    public nav: NavController,
    private navParams: NavParams,
    private viewCtrl: ModalController,
    private modalCtrl: ModalController,
    private platform: Platform,
    private toastCtl: ToastController,
    private mg2uUtils: mygolfUtils
  ) {
    this.title = this.navParams.get('title');
    this.descriptionText = this.navParams.get('description');
    this.headerName = this.navParams.get('headerName');
  }
  close() {
    this.modalCtrl.dismiss();
  }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  ngOnInit() {}

  confirm(value: string) {
    this.modalCtrl.dismiss(value);
  }

  getRoundCourseRatings(roundNo: number) {
    let _filtered = [];
    if (this.roundCourseRatings?.length > 0) {
      _filtered = this.roundCourseRatings.filter((courseRatings: CompetitionRoundCourseRatings) => {
        return courseRatings.roundNo === roundNo;
      });
    } else _filtered = this.roundCourseRatings;
    return _filtered;
  }

  getTeeColor(color: string, type?: string) {
    let teeColor: string;

    if (color === 'White') {
      if (type === 'player') teeColor = 'tee-white-tee-bg';
      else teeColor = 'tee-white';
      return teeColor;
    } else if (color === 'Red') {
      return 'tee-red';
    } else if (color === 'Black') {
      return 'tee-black';
    } else if (color === 'Gold') {
      if (type === 'info') teeColor = 'tee-gold-tee-bg';
      else teeColor = 'tee-gold';
      return teeColor;
    } else if (color === 'Blue') {
      return 'tee-blue';
    }
  }

  getBtnTbox(color: string) {
    let tboxStyle: string;

    if (color === 'White') {
      return 'button-teebox ' + 'button-teebox-white';
    } else return 'button-teebox';
  }
  getTeeColorBG(teeColor: string, teeName?: string) {
    if (teeName === 'White') return '#231f20';
    const _color = teeColor || '#000000';
    if (this.mg2uUtils.lightOrDark(_color) === 'light') {
      return '#231f20';
    } else {
      return '#ffffff';
    }
  }
  // backButtonSub: Subscription;
  // ionViewWillEnter() {
  //   this.backButtonSub = this.platform.backButton.subscribeWithPriority(10000, () => {
  //     MessageDisplayUtil.showMessageToast(
  //       'back button',
  //       this.platform,
  //       this.toastCtl,
  //       3000,
  //       'bottom'
  //     );
  //     this.modalCtrl.dismiss();
  //   });
  //   window.onpopstate = async () => {
  //     this.modalCtrl.dismiss();
  //   };
  // }

  // ionViewWillLeave() {
  //   this.backButtonSub?.unsubscribe();
  // }
}
